import { render, staticRenderFns } from "./ModalProcedimentosVinculados.vue?vue&type=template&id=e0c36c60"
import script from "./ModalProcedimentosVinculados.vue?vue&type=script&lang=ts"
export * from "./ModalProcedimentosVinculados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports